import React, {Component} from 'react';
import { connect } from 'react-redux';
import { sendAnalytics } from '../../../action/homeAction';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import NoConnection from './noConnection'

class ErrorBoundary extends Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, message: "" };
    }
  
    componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({ hasError: true });
      // You can also log the error to an error reporting service
    //   logErrorToMyService(error, info);
    clearTimeout(window.timeoutTimer)
    clearTimeout(window.loaderTimer)
        if(window.FirebasePlugin){
          let layout = localStorage.getItem('LayoutMaster')
            window.FirebasePlugin.setCrashlyticsCustomKey('LayoutMaster', layout)
            window.FirebasePlugin.logError(error.message + "\nStack trace =>  " + info.componentStack);
        }

      //   let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      //   this.props.sendAnalytics(
      //     this.props.guestDetail,
      //     "ERROR BOUNDARY", 
      //     "ENCOUNTERED - ERROR", 
      //     {...label, "layoutTab": this.props.currentHomePage.tabName, errorMessage: error.message + "\nStack trace =>  " + info.componentStack},
      //     0, 
      //     this.props.guestIsLoggedIn
      // );
        console.log("Error boundry catched error: ", error.message + "\nStack trace =>  " + info.componentStack);

        this.setState({message: localStorage.getItem('LayoutMaster') == "webapp-type1" ? 'webapp-type1 is not supported. Please contact support team.': ''})
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <NoConnection error={true} message={this.state.message}/>;
      }
      return this.props.children;
    }
  }

const mapStateToProps = (state) => {
  return {
  guestDetail: state.store.home.guestDetails,
  guestIsLoggedIn: state.store2.guestIsLoggedIn,
  installedAppVersion: state.store.installedAppVersion,
  installedAppBuildNo: state.store.installedAppBuildNo,
  currentWidgets: state.store.sideNavBar.currentWidget,
  }
}

export default connect(
  mapStateToProps,
  {

  }
  )(ErrorBoundary);